import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/common/layout'

Vue.use(Router)

var  routes= [
  {
    path: '/',
    // name: 'home',
    component: Layout,

    meta: {
      title: '首页',
    },
    // 首页
    children: [
      {
        path: '',
        component: () =>
          import("@/views/home")
      }

    ],
    beforeEnter: (to, from, next) => {
      console.log(next)
      let token = '';
      if (localStorage.getItem("userInfo")) {
        token = JSON.parse(localStorage.getItem("userInfo")).token
      }
      if (!token) {
        next({ name: 'login' }); // 禁止跳转
      } else {
        next()
      }
    }

  },
  //
  {
    path: '/userTemplate',
    name: 'home',
    component: Layout,
    meta: {
      title: '我的模板',
      
    },
    children: [
      {
        path: '/userTemplate',
        name: 'userTemplate',
        component: () =>
          import("@/views/fxApply/userTemplate"),

        meta: {
          title: '我的模板',
          hiddenCrumbs: true,
          deepth: 2,
          keepAlive: true
        },
      },
      {
        path: '/createTmp',
        name: 'createTmp',
        component: () =>
          import("@/views/fxApply/createTmp"),
        meta: {
          title: '新建模板',
          hiddenCrumbs: false

        },
      },

      //发送锐信
      {
        path: '/fuxinSend',
        name: 'fuxinSend',
        component: () =>
          import("@/views/fxApply/fuxinSend"),
        meta: {
          title: '发送锐信',
          keepAlive: true,
          deepth:1
        },

       
    
      },

      // 锐信体验
      {
        path: '/experience',
        name: 'experience',
        component: () =>
          import("@/views/fxApply/experience"),

        meta: {
          title: '锐信体验',
        },
      },

    ]
  },

  //复信记录
  {
    path: '/',
    name: 'home',
    component: Layout,
    meta: {
      // title: '复信记录',
    },
    children: [
      // 发送任务记录
      {
        path: '/send',
        name: 'send',
        component: () =>
          import("@/views/record/send"),
        meta: {
          title: '发送任务记录',
        },
      },

    ]
  },

  //复信记录
  {
    path: '/send',
    name: 'home',
    component: Layout,
    meta: {
      title: '发送任务记录',
    },
    children: [

      {
        path: '/sendDetail',
        name: 'sendDetail',
        component: () => import("@/views/record/sendDetail"),
        meta: {
          title: '发送任务详情',
        },
      }
    ]
  },
  //系统管理
  {
    path: '/news',
    name: 'home',
    meta: {
      title: '系统消息',
    },
    component: Layout,
    children: [
      // 系统消息列表
      {
        path: '/news',
        name: 'news',
        meta: {
          title: '系统消息',
          hiddenCrumbs: true
        },
        component: () => import("@/views/system/news"),
      },
      // 系统消息详情
      {
        path: '/newsDetail',
        name: 'newsDetail',
        component: () => import("@/views/system/newsDetail"),
        meta: {
          hiddenCrumbs: false,//面包屑中是否显示该
          title: '系统消息详情',
        },
      }
    ]
  },
  // 用户账户
  {
    path: '/',
    component: Layout,
    meta: {},
    children: [
      // 用户账户
      {
        path: '/user',
        name: 'user',
        component: () =>
          import("@/views/system/user"),
        meta: {
          title: '我的账户',
        },
      }
    ]
  },


  // 登录
  {
    path: '/login',
    name: 'login',
    component: () =>
      import("@/views/login/login"),
    meta: {
      title: '登录',
    },
  },
  // 忘记密码
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () =>
      import("@/views/login/forget-password"),
    meta: {
      title: '找回密码',
    },
  },
  // 短信登录
  {
    path: '/sms-login',
    name: 'sms-login',
    component: () =>
      import("@/views/login/sms-login"),
    meta: {
      title: '短信验证码登录',
    },
  },
  //注册
  {
    path: '/register',
    name: 'register',
    component: () =>
      import("@/views/login/register"),
    meta: {
      title: '注册',
    },
  },



]


const router = new Router({
  mode: 'history',
  routes,
  
})


router.beforeEach((to, from, next) => {
  let token = localStorage.getItem("userInfo") || '';
  // if (localStorage.getItem("userInfo")) {
  //     token = JSON.parse(localStorage.getItem("userInfo")).token
  // }
  let notDetermine = to.path == '/login' || to.path == '/forget-password' || to.path == '/register' || to.path == '/sms-login' || to.path == '/experience' //不需要token的页面
  if (notDetermine) {
      next()
  } else if (!token) {
      next({ name: 'login', query: { path: to.path, params: JSON.stringify(to.query) } }); // 禁止跳转
  } else {
      next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js